export default function ProductsHero() {
  return (
    <section className="relative pt-24 pb-12 md:pt-32 md:pb-16">
      <div className="absolute inset-0 bg-gradient-to-b from-graphite-850 via-graphite-900 to-graphite-900" />
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
            <span className="text-xs font-medium text-silver-300 tracking-wide">
              The StackMap Ecosystem
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Three Ways to <span className="text-emerald-accent">Build</span>
          </h1>
          <p className="text-base md:text-lg text-silver-300 max-w-3xl mx-auto leading-relaxed">
            StackMap BOS delivers 11 connected operational modules for horizontal business management. OMS is our standalone order management and inventory platform for logistics and warehousing. Get Fit is our vertical SaaS for gyms and wellness businesses. And when off-the-shelf isn't enough, we build custom solutions from the ground up.
          </p>
        </div>
      </div>
    </section>
  );
}